import { render, staticRenderFns } from "./confirm-date-dialog.vue?vue&type=template&id=a58f7b22&scoped=true&"
import script from "./confirm-date-dialog.vue?vue&type=script&lang=js&"
export * from "./confirm-date-dialog.vue?vue&type=script&lang=js&"
import style0 from "./confirm-date-dialog.vue?vue&type=style&index=0&id=a58f7b22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58f7b22",
  null
  
)

export default component.exports